import { useDisclosure } from "@chakra-ui/react"
import AugmentationLayout, {
  AugmentationComponents
} from "@pathwright/ux/src/components/augmentation/AugmentationLayout"
import AugmentationPositionedToolbar from "@pathwright/ux/src/components/augmentation/AugmentationPositionedToolbar"
import CertificateState from "../context/CertificateState"
import CertificateAugmentation, {
  useCertificateAugmentationToolbar
} from "../panel/CertificateAugmentation"

const CertificateAugmentationLayout = ({
  Primary,
  children
}: {
  Primary: AugmentationComponents["Primary"]
  children?: React.ReactNode
}) => {
  const toolbar = useCertificateAugmentationToolbar()
  const disclosure = useDisclosure()

  return (
    <CertificateState>
      {children}
      <AugmentationLayout
        components={{
          Primary: Primary,
          Toolbar: !disclosure.isOpen
            ? AugmentationPositionedToolbar
            : undefined,
          Panel: CertificateAugmentation
        }}
        toolbar={toolbar}
        disclosure={disclosure}
        spacing={[10, 10, 10]}
        panelPosition="near"
      />
    </CertificateState>
  )
}

CertificateAugmentationLayout.displayName = "CertificateAugmentationLayout"

export default CertificateAugmentationLayout
